/* RecentSearchBody.styles.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _41 = "._1bsb1osq{width:100%}";
const _40 = "._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}";
const _39 = "._19bvidpf{padding-left:0}";
const _38 = "._n3tdidpf{padding-bottom:0}";
const _37 = "._u5f3idpf{padding-right:0}";
const _36 = "._ca0qidpf{padding-top:0}";
const _35 = "@media (min-width:64rem){._ne9p1370:before{content:\"Clear search history\"}}";
const _34 = "._j6xt1dty:active{background:var(--ds-background-neutral-subtle-pressed,#091e4224)}";
const _33 = "._19lc166n:hover{background:var(--ds-background-neutral-subtle-hovered,#091e420f)}";
const _32 = "._1kt91kbs:before{content:\"Clear all\"}";
const _31 = "._x5dbugt7:focus-visible:not(:active){outline:2px solid var(--ds-border-focused,#388bff)}";
const _30 = "._1bah1h6o{justify-content:center}";
const _29 = "._2lx21bp4{flex-direction:column}";
const _28 = "._1e0c116y{display:inline-flex}";
const _27 = "._vwz4qgp8{line-height:1.2rem}";
const _26 = "._y3gn1h6o{text-align:center}";
const _25 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _24 = "._80omtlke{cursor:pointer}";
const _23 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _22 = "._1yt416r1{padding:var(--ds-space-0,0) var(--ds-space-100,8px)}";
const _21 = "._11q7vuon{background:var(--ds-surface,#fff)}";
const _20 = "._18u0idpf{margin-left:0}";
const _19 = "._otyridpf{margin-bottom:0}";
const _18 = "._2hwxidpf{margin-right:0}";
const _17 = "._19pkidpf{margin-top:0}";
const _16 = "._2rko12b0{border-radius:var(--ds-radius-small,4px)}";
const _15 = "._19itglyw{border:none}";
const _14 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _13 = "._1e0cglyw{display:none}";
const _12 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _11 = "._1e0c1ule{display:block}";
const _10 = "._k48p1nn1{font-weight:400}";
const _9 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _8 = "._1wyboqnp{font-size:.75rem}";
const _7 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _6 = "._vwz4f6fq{line-height:18px}";
const _5 = "._1wpz1fhb{align-self:stretch}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1bah1yb4{justify-content:space-between}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._1yt4oxwe{padding:var(--ds-space-250,20px) var(--ds-space-250,20px) var(--ds-space-050,4px) var(--ds-space-300,24px)}";
export const SearchSubHeader = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4oxwe _1e0c1txw _1bah1yb4 _4cvr1h6o _1wpz1fhb _vwz4f6fq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchSubHeader.displayName = 'SearchSubHeader';
}
export const LabelMobile = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1gjq _1wyboqnp _ect418aq _k48p1nn1 _1e0c1ule _dm25glyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LabelMobile.displayName = 'LabelMobile';
}
export const LabelDesktop = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9, _10, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1gjq _1wyboqnp _ect418aq _k48p1nn1 _1e0cglyw _dm251ule", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LabelDesktop.displayName = 'LabelDesktop';
}
export const ClearButton = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _9, _8, _10, _27, _28, _29, _30, _4, _31, _32, _33, _34, _35]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itglyw _2rko12b0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _11q7vuon _1yt416r1 _zulpu2gc _80omtlke _syaz131l _y3gn1h6o _ect418aq _1wyboqnp _k48p1nn1 _vwz4qgp8 _1e0c116y _2lx21bp4 _1bah1h6o _4cvr1h6o _x5dbugt7 _1kt91kbs _19lc166n _j6xt1dty _ne9p1370", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ClearButton.displayName = 'ClearButton';
}
export const QueriesContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_36, _37, _38, _39, _17, _18, _19, _20, _40, _41]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _n3tdu2gc _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  QueriesContainer.displayName = 'QueriesContainer';
}